/* eslint-disable no-console */
import {Table} from 'antd';
import React from 'react';

import useJSONStore from '../../../store/StaticJson/jsonStore';
import {formatIndian} from '../../../utils/formatIndian';
import {FacilityKey} from '../../Forms/Constants/IP/FacilityKeyLabel';
import {
  ProductInfoKey,
  ProductInfoLabel
} from '../../Forms/Constants/Products/ProductInfoKeyLabel';
import changeUnit from '../../Forms/Utils/changeUnit';

const ProductFacilityDis: React.FC<{
  dataSource: any;
  type: 'facility' | 'raw';
  facilities: any[];
}> = ({dataSource, type, facilities}) => {
  const rawMaterials = useJSONStore.getState().rawMaterials;
  const columns: any = [
    {
      title: ProductInfoLabel.FACILITIES,
      dataIndex: ProductInfoKey.SINGLE_FACILITY,
      render: (value: number) => {
        return (
          <>
            {
              facilities?.find((item: any) => {
                return item._id === value;
              })?.[FacilityKey.FACILITY_NAME]
            }
          </>
        );
      }
    }
  ];

  const columnsRaw: any = [
    {
      title: ProductInfoLabel.RAW_MATERIAL_ID,
      dataIndex: ProductInfoKey.RAW_MATERIAL_ID,
      render: (value: number) => {
        return (
          <>
            {
              rawMaterials?.find((item: any) => {
                return item.value === value;
              })?.label
            }
          </>
        );
      }
    },
    {
      title: ProductInfoLabel.WEIGHT,
      dataIndex: undefined,
      render: (value: any) => {
        return `${formatIndian(value?.[ProductInfoKey.WEIGHT])} ${changeUnit(
          rawMaterials?.find((item: any) => {
            return item.value === value?.[ProductInfoKey.RAW_MATERIAL_ID];
          })?.state
        )}`;
      }
    }
  ];

  return (
    <Table
      bordered={false}
      columns={type === 'facility' ? columns : columnsRaw}
      dataSource={dataSource}
      pagination={{pageSize: 50}}
      scroll={{y: 240}}
      rowKey="_id"
      // tableLayout="auto"
    />
  );
};

export default ProductFacilityDis;
